import _ from '@/utils/lodash-optimized'

const email = (msg = 'Email should have valid format') => {
  const emailRegexp =
    /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|tech|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i

  return v => {
    if (!v || v === '') {
      return null
    }

    if (!v.match(emailRegexp)) {
      return msg
    }
    return null
  }
}

const integer =
  (msg = 'Please provide integer value') =>
    v =>
      !(v || '').match(/^\d+$/) && msg

const money =
  (msg = 'Please provide decimal value (i.e. xxx.yy)') =>
    v =>
      !(v || '').match(/^\d+(\.\d\d)?$/) && msg

const phone = (msg = 'Phone should have valid format') => {
  const phoneRegexp = /^(\d{3}\.\d{3}\.\d{4}|\d{10})$/i

  return v => {
    if (!v || v === '') {
      return null
    }

    if (!v.match(phoneRegexp)) {
      return msg
    }
    return null
  }
}

const required =
  (msg = 'This field is required') =>
    v => {
      if (_.isNil(v) || v === '') {
        return msg
      }
      return null
    }

const empty =
  (msg = 'This field should be empty') =>
    v => {
      if (_.isNil(v) || v === '') {
        return null
      }

      return msg
    }

const or = (v1, v2) => v => {
  const r1 = v1(v)
  if (r1 === null || r1 === false) {
    return null
  }

  const r2 = v2(v)
  if (r2 === null || r2 === false) {
    return null
  }

  return `${r1} or ${r2}`
}

export const Validators = {
  phone,
  email,
  required,
  integer,
  money,
  empty,
  or
}
